import React from "react";
import { servicesContent } from "../mock";
import useReveal from "../hooks/useReveal";
import { Truck, PackageOpen, Forklift } from "lucide-react";

const iconMap = {
  truck: Truck,
  package: PackageOpen,
  forklift: Forklift,
};

const Services = () => {
  const ref = useReveal();
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <h2 className="heading-navy text-center font-semibold text-3xl md:text-4xl tracking-tight">
          {servicesContent.title}
        </h2>

        <div ref={ref} className="reveal mt-14 grid md:grid-cols-3 gap-10 lg:gap-16">
          {servicesContent.items.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div key={i} className="group text-center md:text-left">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#F6E8E8] text-[#E23028] transition-all duration-300 group-hover:bg-[#E23028] group-hover:text-white group-hover:-translate-y-1">
                    <Icon size={32} strokeWidth={1.8} />
                  </div>
                </div>
                <h3 className="heading-navy font-bold text-lg mb-3">{item.title}</h3>
                <p className="text-[#7a7a85] text-[15px] leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
